var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeaderboarddefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#646464"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_46840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1742 11.3498H14.7242V22.1998H13.1742V11.3498ZM16.2742 12.8998H17.8242V22.1998H16.2742V12.8998ZM19.3742 9.7998H20.9242V22.1998H19.3742V9.7998ZM10.0742 15.9998H11.6242V22.1998H10.0742V15.9998Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_46840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6,
    height: 18.6,
    fill: "white",
    transform: "translate(6.19922 6.7002)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboarddefault);
export default __webpack_public_path__ + "static/media/leaderboarddefault.cda75f469d871886dd00cb683234aceb.svg";
export { ForwardRef as ReactComponent };